module.exports = "<div class=\"background\" [ngClass]=\"{'opened' : isOpened, 'closed' : !isOpened}\">\r\n  <div class=\"dialog\">\r\n    <header>\r\n      <p>{{reason}}</p>\r\n    </header>\r\n    <main>\r\n      {{guidense}}\r\n    </main>\r\n    <nav>\r\n      <button mat-button (click)=\"decline()\">{{buttonOneName}}</button>\r\n      <button mat-button (click)=\"confirm()\" *ngIf=\"isDialog()\">{{buttonTwoName}}</button>\r\n    </nav>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/warnings/warnings.component.html
// module id = ./src/app/modals/warnings/warnings.component.html
// module chunks = main